import equal from 'fast-deep-equal/react';
import styles from './FeaturesLayout.scss';
import { useAppSelector } from '~/hooks';
import { RootState } from '~/store';
import MainFeaturesLayout from '~/Components/Features/MainFeaturesLayout/MainFeaturesLayout';
import { ShipFeaturesMap } from '~/types';

interface IFeaturesLayout {
    shipId: number,
}

interface IStateSelector {
    shipFeaturesMap: ShipFeaturesMap,
}

const stateSelector = (state: RootState): IStateSelector => {
    return {
        shipFeaturesMap: state.shipFeatures.shipFeaturesMap,
    };
};

const FeaturesLayout = ({ shipId }: IFeaturesLayout) => {
    const state = useAppSelector(stateSelector, equal);
    const currentFeature = state.shipFeaturesMap[shipId];

    if (!currentFeature) {
        return null;
    }

    return (
        <div className={styles.features}>
            {currentFeature.categories?.map((categories, key) => {
                const hasAllFeaturesTitles = categories.features?.every((feature) => feature.title);
                if (!hasAllFeaturesTitles) {
                    return null;
                }
                return (
                    <div className={styles.feature} key={`feature_${key}`}>
                        <div className={styles.featureIcon} style={{ backgroundImage: `url(${categories.category?.icons.default})` }} />
                        <div className={styles.featureContent}>
                            <div className={styles.featureTitle}>{categories.category?.title}</div>
                            <MainFeaturesLayout
                                features={categories.features}
                                className={styles.featureLine}
                                circleSize={styles.featureCircle}
                                detailedFeatures={true}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default FeaturesLayout;
